export class Image {
    filename: string;
    uploaded: string;
    aligned: string;
    action: string;
    error: any;
}
